"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["MISSING_SITEID_ERROR_MSG"] = "MISSING_SITEID_IN_REDIRECT_BANNER_REQUEST";
    ErrorMessages["BANNER_API_ERROR_MSG"] = "ERROR_WHILE_REDIRECT_BANNER_API_CALL";
})(ErrorMessages = exports.ErrorMessages || (exports.ErrorMessages = {}));
//# sourceMappingURL=error-messages.js.map